import {departmentStateActions} from '../../const/actionType';

export const setDepartments = (departments) => ({
  type: departmentStateActions.SET_DEPARTMENTS,
  departments,
});

export const setSelectedDepartment = (selected) => ({
  type: departmentStateActions.SET_SELECTED_DEPARTMENT,
  selected,
});

export const setIsDepartmentReady = (value) => ({
  type: departmentStateActions.SET_IS_DEPARTMENT_READY,
  value,
});
